<template>
  <v-form ref="form" class="">
    
    <BaseUtil
      ref="util"
      :pageLoading="pageLoading"
    />

    <v-row>

      <v-col cols="12" sm="12" md="12">
        <v-autocomplete
          v-model="entry.storageId"
          v-bind="getObject('storageId')"
          label="Estoque"
          :items="extraData.accountContext.allStorages"
          item-value="id"
          item-text="name"
          :disabled="readOnly"
          autocomplete="off"
          @input="selectStorage"
        >
          <!-- <template v-slot:append-outer>
            <StorageNew
              :inlineAddButton="true"
              @entry-created="sourceStorageCreated"
              modelNameSingular="Estoque de Origem"
            />
          </template> -->
        </v-autocomplete>
      </v-col>

      <v-col cols="12">
        <v-autocomplete
          v-model="entry.itemId"
          v-bind="getObject('itemId')"
          label="Item"
          :items="storageAvailableItems"
          item-value="id"
          item-text="name"
          @input="selectItem"
          :hint="consumedItemAdditionalInfo(entry.item)"
          persistent-hint
          autocomplete="off"
          :loading="storageAvailableItemsLoading"
          :disabled="readOnly || !entry.storageId"
        >
          <template v-slot:item="data">
            <v-list-item-content>
              <v-list-item-title>{{data.item.name}}</v-list-item-title>
              <v-list-item-subtitle>{{consumedItemAdditionalInfo(data.item)}}</v-list-item-subtitle>
            </v-list-item-content>
          </template>
        </v-autocomplete>
      </v-col>

      <v-col cols="12">
        <v-autocomplete
          :disabled="!entry.itemId || readOnly"
          v-model="entry.packagingId"
          v-bind="getObject('packagingId')"
          label="Embalagem"
          :items="packagingList"
          item-value="id"
          item-text="name"
          @input="selectPackaging"
          :loading="packagingListLoading"
          autocomplete="off"
        >
        </v-autocomplete>
      </v-col>

      <v-col cols="12" sm="6">
        <MaskedTextField
          v-if="renderComponent"
          :inputData.sync="packagingQuantity"
          mask-type="currency_10d"
          label="Quantidade de Embalagens"
          :disabled="!entry.packagingId || readOnly"
          @update:inputData="changePackagingQuantity"
          autocomplete="off"
          :suffix="entry.packaging ? entry.packaging.text : ''"
          :key="packagingQuantityKey + 'packagingQuantityKey'"
        />
        <!--   -->
      </v-col>


      <v-col cols="12" sm="6">
        <MaskedTextField
          v-if="renderComponent"
          v-bind="getObject('quantity')"
          :inputData.sync="entry.quantity"
          mask-type="currency_10d"
          label="Quantidade Unitária"
          :suffix="entry.packaging ? entry.packaging.unit.name : ''"
          :disabled="!entry.packagingId || readOnly"
          autocomplete="off"
          :hint="quantityHint"
          persistent-hint
          @update:inputData="changeQuantity"
          :key="quantityKey + 'quantityKey'"
        />
      </v-col>

    </v-row>
  </v-form>
</template>

<script>
import MaskedTextField from "@shared_components/masked_text_field.vue"
import DateField from "@shared_components/date_field.vue";
// import StorageTransferItemsIndex from "@models/storages/storage_transfers/exit_movement_items/index.vue";
import StorageNew from "@models/storages/new.vue"
import BaseUtil from "@shared_components/base_util.vue";
import gql from 'graphql-tag'

export default {
  data() {
    return {
      entryAttributes: {},
      pageLoading: false,
      storageAvailableItems: [],
      packagingList: [],
      storageAvailableItemsLoading: false,
      packagingListLoading: false,
      availableQuantity: 0,
      packagingQuantity: 0,
      packagingQuantityKey: 0,
      quantityKey: 0,
      renderComponent: true,
      originalEditQuantity: null,
    };
  },
  props: {
    entry: Object,
    extraData: Object,
    readOnly: {
      type: Boolean,
      default: false
    },
    isEdit: { // utilizado para definir se o form é de edição
      type: Boolean,
      default: false
    },
    modelNameSingular: String,
  },
  components: {
    MaskedTextField: MaskedTextField,
    DateField: DateField,
    // StorageTransferItemsIndex: StorageTransferItemsIndex,
    StorageNew: StorageNew,
    BaseUtil: BaseUtil,
  },
  created() {
    this.entryAttributes = this.setupEntryAttributes(this.entry);

    if (this.entry.storageId) {
      this.selectStorage();
    }
    if (this.entry.quantity) {
      this.originalEditQuantity = this.entry.quantity;
    }
  },
  mounted() {
  },
  computed: {
    quantityHint: function() {
      return this.entry.packaging ? "Quantidade disponível: " + this.numberToDecimal(this.availableQuantity) + " " + this.entry.packaging.unit.name : null
    }
  },
  methods: {
    selectStorage: function(clearItem=false) {
      if (this.entry.storageId) {
        this.entry.storage = this.extraData.accountContext.allStorages.find(obj => obj.id == this.entry.storageId);

        if (clearItem) {
          this.entry.item = null;
          this.entry.itemId = null;
        }

        this.storageAvailableItemsLoading = true;
        this.$apollo
          .query({
            query: AVAILABLE_ITEMS_FOR_STORAGE_QUERY,
            variables: {
              storageId: this.entry.storageId
            },
            fetchPolicy: "no-cache"
          })
          .then(response => {
            // console.log("itens for stock transfer", response);
            this.storageAvailableItems = response.data.accountContext.availableItemsInStorageForTransformation;

            if (this.entry.itemId && this.isEdit) {
              let itemFromList = this.storageAvailableItems.find(obj => obj.id == this.entry.itemId);
              if (!itemFromList) {
                this.storageAvailableItems.unshift(this.entry.item);
              }
              this.selectItem(false);
            }
            
            if (this.storageAvailableItems && this.storageAvailableItems.length == 1 && !this.entry.itemId) {
              this.entry.item = this.storageAvailableItems[0];
              this.entry.itemId = this.entry.item.id;
              this.selectItem(true);
            }
            // this.entry = response.data.accountContext.transferItem;
            // this.extraData = response.data;
          })
          .catch(response => console.log(response))
          .finally(() => (this.storageAvailableItemsLoading = false));
      }
      
    },
    selectItem: function(clearPackaging=false) {
      // console.log("entry.item", this.entry.item);
      if (this.entry.itemId) {
        this.entry.item = this.storageAvailableItems.find(obj => obj.id == this.entry.itemId);
        // this.clearFields();
        if (clearPackaging) {
          this.entry.packagingId = null;
          this.entry.packaging = null;
        }
        this.packagingListLoading = true;
        this.$apollo
          .query({
            query: AVAILABLE_PACKAGING_FOR_ITEM_QUERY,
            fetchPolicy: "no-cache",
            variables: {
              itemId: this.entry.itemId,
              storageId: this.entry.storageId
            }
          })
          .then(response => {
            // console.log("response dos packaging", response);
            this.packagingList = response.data.accountContext.availableItemPackagingsForStorage;

            if (this.entry.item && this.entry.packagingId && this.isEdit) {
              let packagingFromList = this.packagingList.find(obj => obj.id == this.entry.packagingId)
              if (!packagingFromList) {
                this.packagingList.unshift(this.entry.packaging)
              }
              // this.selectPackaging();
            }

            if (this.packagingList.length == 1 && !this.entry.packagingId) {
              this.entry.packagingId = this.packagingList[0].id;
            }
            this.selectPackaging();
            if (this.entry.packagingId && this.entry.quantity && this.isEdit) {
              this.changeQuantity();
            } 
          })
          .catch(response => console.log(response))
          .finally(() => (this.packagingListLoading = false));
      }
    },
    selectPackaging: function() {
      if (this.entry.packagingId) {
        this.entry.packaging = this.packagingList.find(obj => obj.id == this.entry.packagingId);
        // this.stockListLoading = true;
        this.$apollo
          .query({
            query: AVAILABLE_QUANTITY_FOR_ITEM_QUERY,
            fetchPolicy: "no-cache",
            variables: {
              itemId: this.entry.itemId,
              packagingId: this.entry.packagingId,
              storageId: this.entry.storageId
            }
          })
          .then(response => {
            // console.log("response dos stocks", response)
            this.availableQuantity = response.data.accountContext.availableQuantityForItem;

            this.entryAttributes.quantity.rules = [];
            this.entryAttributes.quantity.rules.push(this.requiredRule);
            this.entryAttributes.quantity.rules.push(this.minRequiredRule);
            let availableQuantity = _.round(this.availableQuantity, 10);
            // usado para contabilizar a quantidade já salva no edit
            if (this.isEdit) {
              availableQuantity = _.round(availableQuantity + this.originalEditQuantity, 10);
            }
            this.entryAttributes.quantity.rules.push(this.maxValueRule(availableQuantity));
          })
          .catch(response => console.log(response))
          .finally(() => (this.stockListLoading = false));
      }
    },
    consumedItemAdditionalInfo: function(item) {
      let info = ""
      if (item) {
        info = 'Unidade de Consumo: ' + item.unit.name + (item.brand ? ', Marca: ' + item.brand.name : '') + (item.typeText ? ', Tipo: ' + item.typeText : '')
      }
      return info;
    },
    changeQuantity: function() {
      this.packagingQuantity = _.round(this.entry.quantity / this.entry.packaging.size, 10);
      this.packagingQuantityKey++;
    },
    changePackagingQuantity: function() {
      this.entry.quantity = _.round(this.packagingQuantity * this.entry.packaging.size, 10);
      this.quantityKey++;
    },
    getObject: function(element, component) {
      return this.entryAttributes[element];
    },
    isFormValid: function() {
      if (this.$refs.form.validate()) {
        return true;
      } else {
        setTimeout(function(){
          document.querySelector(".v-messages.error--text:first-of-type").scrollIntoView({ behavior: 'smooth', block: 'center' });
        }, 500);
      }
      return false;
    },
    resetFormInputs: function() {
      this.$refs.form.resetValidation();
    },
    sourceStorageCreated: function(storage) {
      this.extraData.accountContext.allStorages.unshift(storage);
      this.entry.sourceStorageId = storage.id;
      this.entry.sourceStorage = storage;
    },
    targetStorageCreated: function(storage) {
      this.extraData.accountContext.allStorages.unshift(storage);
      this.entry.targetStorageId = storage.id;
      this.entry.targetStorage = storage;
    },
  }
};

const AVAILABLE_ITEMS_FOR_STORAGE_QUERY = gql `
query($storageId: ID!) {
  accountContext {
    availableItemsInStorageForTransformation(storageId: $storageId) {
      id
      name
      unit {
        id
        name
      }
      brand {
        id
        name
      }
      typeText
    }
  }
}
`;

const AVAILABLE_PACKAGING_FOR_ITEM_QUERY = gql `
  query ($itemId: ID!, $storageId: ID!) {
    accountContext {
      availableItemPackagingsForStorage(itemId: $itemId, storageId: $storageId){
        id
        name
        text
        size
        unit{
          id
          name
        }
        customUnit{
          id
          name
        }
      }
    }
  }
`;

const AVAILABLE_QUANTITY_FOR_ITEM_QUERY = gql `
  query ($itemId: ID!, $packagingId: ID!, $storageId: ID!) {
    accountContext {
      availableQuantityForItem(itemId: $itemId, packagingId: $packagingId, storageId: $storageId)
    }
  }
`;

</script>

<style scoped></style>
